import { hc, parseResponse } from "hono/client";
//#region src/client.ts
const DEFAULT_BASE_URL = "http://localhost:3000";
const PROD_BASE_URL = "https://blob-store.locuslabs.com/prod";
const createBlobClient = ({ token, baseUrl = DEFAULT_BASE_URL, fetcher = fetch } = {}) => hc(baseUrl, {
	headers: { ...token ? { "x-api-key": token } : {} },
	fetch: fetcher
});
function createBlobHelper(opts) {
	const fetcher = opts.fetcher ?? fetch;
	const client = createBlobClient({
		...opts,
		baseUrl: opts.baseUrl ?? PROD_BASE_URL,
		fetcher
	});
	return {
		client,
		getBlob: async (blobId, options) => {
			return { body: await parseResponse(client.v1[":id"].$get({
				param: { id: blobId },
				query: {
					folder: options?.folder,
					bucket: options?.bucket,
					redirect: options?.redirect === false ? "false" : "true"
				}
			})) };
		},
		putBlob: async (options, data) => {
			const json = await parseResponse(client.v1.$get({
				query: {
					folder: options.folder,
					bucket: options.bucket
				},
				header: { Type: options.type }
			}));
			const uploadBody = typeof data === "string" || data instanceof Blob ? data : JSON.stringify(data);
			const uploadRes = await fetcher(json.url, {
				method: "PUT",
				body: uploadBody,
				headers: { "Content-Type": options.type }
			});
			if (!uploadRes.ok) throw new Error(`Blob upload failed: ${uploadRes.status} ${uploadRes.statusText}`);
			return { body: json };
		}
	};
}
//#endregion
export { createBlobClient, createBlobHelper };

//# sourceMappingURL=client.mjs.map